import { extendObservable, intercept, observe } from 'mobx';
import numeral from 'numeral';
import { DEFAULT_SUBMODALITY_ID } from '@constants/modalities';

import * as observers from './observers';

const loadingMessages = require('../../../json/loadingMessages.json');

class QuoteStore {
  initialState = {
    ModalityId: '',
    Submodalities: null,
    SubmodalityId: DEFAULT_SUBMODALITY_ID,
    SubmodalityIndex: null,
    SubmodalityDefaultValue: 0,
    SubmodalityDescription: '',
    SecuredAmount: 0,
    AddPercentage: false,
    TotalAmount: 0,
    DurationInDays: 0,
    DurationYears: 0,
    IsAdTrabalhista: false,
    isCircular662Active: false, // TODO: BEX-1706 Remover codigo inativo medida salvamento
    Email: '',
    SignUpNews: false,
    Quote: {},
    Parameters: {},
    Lead: {},
    calculateQuoteLoadingMessage: loadingMessages[0],
    modalityTexts: '',
    origin: 0,
    ContactName: '',
    CompanyName: '',
    CanDetachBroker: false,
    BrokerDetachmentPath: null,
    /* Questionário */
    modalityPathway: [1], // Question IDs
    /* Performance */
    ContractValue: 0,
    WarrantyPercentage: '',
    MaxWarrantyPercentage: '',
  };

  constructor() {
    const initialStateCopy = JSON.parse(JSON.stringify(this.initialState));
    extendObservable(this, initialStateCopy);
  }

  reset() {
    const exceptionsArray = ['Lead', 'Email', 'origin'];

    Object.keys(this.initialState).forEach((k) => {
      if (exceptionsArray.includes(k)) return;
      this[k] = this.initialState[k];
    });
  }

  getQuotePresentationalData() {
    const { Quote } = this;
    const {
      cotacaoId,
      cotadorGarantiaParcelas,
      premioLiquido,
      importanciaSegurada,
      razaoSocialTomador,
      duracaoVigencia,
      possuiCustasJudiciais,
      adicionalTrabalhista,
      tokenDocumento,
      juros,
      modalidadeId,
      modalidade,
      submodalidade,
      shareLinks,
      isResumed,
      totalWithCredits,
    } = Quote;

    return {
      cotacaoId,
      cotadorGarantiaParcelas,
      premioLiquido: numeral(premioLiquido).format(),
      rawTotal: premioLiquido,
      importanciaSegurada: numeral(importanciaSegurada).format(),
      razaoSocialTomador,
      duracaoVigencia,
      possuiCustasJudiciais,
      adicionalTrabalhista,
      documentHash: tokenDocumento,
      possuiJuros: juros,
      modalidadeId,
      modalidade,
      submodalidade,
      shareLinks,
      isResumed,
      totalWithCredits,
    };
  }
}

const quoteStore = new QuoteStore();
if (process.env.NODE_ENV === 'development') window.quoteStore = quoteStore;

intercept(quoteStore, 'ModalityId', (change) => {
  observers.resetStoreOnModalityChange(change, quoteStore);
  observers.changeDefaultPercentageOnModalityChange(change, quoteStore);
  observers.updateGlobalsOnModalityChange(change, quoteStore);

  return change;
});

observe(quoteStore, 'TotalAmount', (change) => {
  observers.updateGlobalsOnTotalAmountChange(change, quoteStore);
  return change;
});

observe(quoteStore, 'DurationInDays', (change) => {
  observers.updateGlobalsOnDurationInDaysChange(change);
  return change;
});

observe(quoteStore, 'Quote', (change) => {
  observers.updateGlobalsOnQuoteChanged(change, quoteStore);
  return change;
});

observe(quoteStore, 'ContractValue', (change) => {
  observers.updateLeadOnContractValueChanged(change, quoteStore);
  return change;
});

observe(quoteStore, 'ModalityId', (change) => {
  observers.updateLeadOnModalityChanged(change, quoteStore);
  return change;
});

export default quoteStore;
